import { M3Presentaciones } from "./m3-presentaciones";

export class M3PrdLista{
    IDLISTA:string;
    SKU:string;
    LOTE:string;
    PRECIO:number;
    LB: number;
    LC: number;
    LD: number;
    SUBINDICE: string;
    PORIGINAL: number;
    public M3Presentaciones = new Array<M3Presentaciones>();
}